/** Published figure presentation, distinct from flow/point-in-time analytical period basis. */
export const FIGURE_PERIOD_BASES = ['actual', 'estimate', 'forecast'] as const;
export type FigurePeriodBasis = (typeof FIGURE_PERIOD_BASES)[number];

/** A closed presentation enum, never derived from dates, labels or certainty. */
export function readFigurePeriodBasis(value: unknown): FigurePeriodBasis | undefined {
  return FIGURE_PERIOD_BASES.find(basis => basis === value);
}

export type FigureBasisCarrier = Readonly<{
  periodBasis?: FigurePeriodBasis;
  timeframe?: Readonly<{ periodBasis?: FigurePeriodBasis; asOf?: string | null }>;
  numericBinding?: FigureBasisCarrier | null;
}>;

/** Copies agreeing declarations; conflicting declarations leave presentation unspecified. */
export function figurePeriodBasis(figure: FigureBasisCarrier | null | undefined,
  declaration?: FigurePeriodBasis): FigurePeriodBasis | undefined {
  const declared = [figure?.periodBasis, figure?.timeframe?.periodBasis,
    figure?.numericBinding?.periodBasis, figure?.numericBinding?.timeframe?.periodBasis]
    .filter((basis): basis is FigurePeriodBasis => basis !== undefined);
  const basis = agreedFigurePeriodBasis(declared);
  return declaration === undefined || declaration === basis ? basis : undefined;
}

/** Every populated declaration must agree, including a duplicate with missing metadata. */
export function agreedFigurePeriodBasis(bases: readonly (FigurePeriodBasis | undefined)[]): FigurePeriodBasis | undefined {
  const first = readFigurePeriodBasis(bases[0]);
  return first && bases.every(basis => basis === first) ? first : undefined;
}
